/**
 * Special survey options shared by the survey editors.
 *
 * The free-text option is labelled "Champ libre"; "Autre" is its former label,
 * still recognised so that surveys created before the rename keep working.
 */
export const CUSTOM_ANSWER_OPTION = 'Champ libre'
export const CUSTOM_ANSWER_OPTIONS = ['Champ libre', 'Autre']
export const NO_REPLY_OPTION = 'Ne souhaite pas répondre'

export function optionLabel (option) {
  if (option && typeof option === 'object') return option.option
  return option
}

export function isCustomAnswerOption (option) {
  return CUSTOM_ANSWER_OPTIONS.includes(optionLabel(option))
}

export function isNoReplyOption (option) {
  return optionLabel(option) === NO_REPLY_OPTION
}

/** Options the admin cannot edit by hand: they are added through the shortcuts. */
export function isLockedOption (option) {
  return isCustomAnswerOption(option) || isNoReplyOption(option)
}
